const translations = {
  leaveChatPopover: {
    item: "Leave this chat"
  }
};

export default translations;
